
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { MailOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Typography } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import AuthLayout from "../../layouts/auth.layout";
import { requestResetPassword } from "../../services/auth.service";
import EmailSVG from "../../public/images/email.svg";
import { ErrorMessageIcon, SuccessMessageIcon } from "../../constants/icons";
import useTranslation from "next-translate/useTranslation";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const { t, lang } = useTranslation("forgot-pass");
  // Local states.
  const [isLoading, setIsLoading] = useState(false);

  const router = useRouter();

  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);
      const result = await requestResetPassword(values.email);
      message.success({
        icon: (
          <div>
            <SuccessMessageIcon />
          </div>
        ),
        // content: currentLocale.forgotPasswordPage.resetLinkSent,
        content: t("reset-link-sent"),
      });
    } catch (e) {
      message.error({
        icon: (
          <div>
            <ErrorMessageIcon />
          </div>
        ),
        // content: currentLocale.forgotPasswordPage.resetLinkFailed,
        content: t("reset-link-failed"),
      });
    } finally {
      setIsLoading(false);
    }
  };
  const defaultValue = { email: "" };

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <Text style={{ fontSize: "28px", fontFamily: "Inter" }}>
          {t("forgot-pass")}
        </Text>
      </div>
      {/* <Title level={1}>
          {currentLocale.forgotPasswordPage.forgotPassword}
        </Title>
        <Text type="secondary" style={{ fontSize: "1.5em" }}>
          {currentLocale.forgotPasswordPage.enterCredentials}
        </Text> */}

      <Form
        onFinish={onFinish}
        layout="vertical"
        form={form}
        initialValues={defaultValue}
        style={{ marginTop: "10%" }}
      >
        <Form.Item
          name="email"
          // label="E-mail"
          hasFeedback
          rules={[
            {
              type: "email",
              // message: currentLocale.forgotPasswordPage.invalidEmailError,
              message: t("invalid-email"),
            },
            {
              required: true,
              // message: currentLocale.forgotPasswordPage.inputEmailError,
              message: t("input-email"),
            },
          ]}
        >
          <Input
            id="forgotPasswordInput"
            // prefix={<MailOutlined className="site-form-item-icon" />}
            prefix={<EmailSVG />}
            placeholder={t("email-placeholder")}
            style={{
              borderRadius: "8px",
              height: "45px",
              fontSize: "16px",
            }}
          ></Input>
        </Form.Item>

        <Form.Item>
          <Button
            loading={isLoading}
            type="primary"
            htmlType="submit"
            style={{
              width: "100%",
              height: "40px",
              fontSize: "18px",
              borderRadius: "8px",
            }}
          >
            {t("get-password")}
          </Button>
        </Form.Item>
      </Form>
      <div style={{ fontSize: "16px" }}>
        <Link href="/login">
          <a style={{ color: "#1890ff" }}>
            {/* {currentLocale.forgotPasswordPage.backToLogin} */}
            {t("back")}
          </a>
        </Link>
      </div>
    </>
  );
};
ForgotPassword.layout = AuthLayout;
export default ForgotPassword;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/forgot-password',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  